import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "@eudonet/opal/styles";
import "@eudonet/opal/styles/design-tokens.css";
import "./shared/styles/main.css";
import "remixicon/fonts/remixicon.css";
import router from "./router";
import i18n from "./shared/i18n";
import { logger } from "./services/loggerService";
import { moduleRegistry } from "./router/moduleRegistry";
import { SHELL_CONTRACTS_KEY } from "./contracts/ShellContracts";
import consentModule from "./modules/consent";
import documentsModule from "./modules/documents";
const app = createApp(App);
app.use(createPinia());
app.use(i18n);
// Build the Shell contracts and register feature modules. Module routes MUST be added
// before app.use(router) so they exist on first navigation.
const shellContracts = { logger, router, app, i18n };
moduleRegistry.initialize(shellContracts);
moduleRegistry.registerModule(consentModule);
moduleRegistry.registerModule(documentsModule);
moduleRegistry.getModuleRoutes().forEach((route) => router.addRoute(route));
app.use(router);
app.provide(SHELL_CONTRACTS_KEY, shellContracts);
router.afterEach((to) => {
    const titleKey = to.meta.titleKey;
    document.title = titleKey
        ? `${i18n.global.t("common.appName")} - ${i18n.global.t(titleKey)}`
        : i18n.global.t("common.appName");
});
app.mount("#app");
